/* tslint:disable:all */
import { Category } from "types/category";

export class CatalogCo {
  public static cities: Category[] = [
    { value: "001", text: "MEDELLIN", main: "05" },
    { value: "002", text: "ABEJORRAL", main: "05" },
    { value: "004", text: "ABRIAQUI", main: "05" },
    { value: "021", text: "ALEJANDRIA", main: "05" },
    { value: "030", text: "AMAGA", main: "05" },
    { value: "031", text: "AMALFI", main: "05" },
    { value: "034", text: "ANDES", main: "05" },
    { value: "036", text: "ANGELOPOLIS", main: "05" },
    { value: "038", text: "ANGOSTURA", main: "05" },
    { value: "040", text: "ANORI", main: "05" },
    { value: "044", text: "ANZA", main: "05" },
    { value: "045", text: "APARTADO", main: "05" },
    { value: "051", text: "ARBOLETES", main: "05" },
    { value: "055", text: "ARGELIA", main: "05" },
    { value: "059", text: "ARMENIA", main: "05" },
    { value: "079", text: "BARBOSA", main: "05" },
    { value: "086", text: "BELMIRA", main: "05" },
    { value: "088", text: "BELLO", main: "05" },
    { value: "091", text: "BETANIA", main: "05" },
    { value: "093", text: "BETULIA", main: "05" },
    { value: "101", text: "CIUDAD BOLIVAR", main: "05" },
    { value: "107", text: "BRICEÑO", main: "05" },
    { value: "113", text: "BURITICA", main: "05" },
    { value: "120", text: "CACERES", main: "05" },
    { value: "125", text: "CAICEDO", main: "05" },
    { value: "129", text: "CALDAS", main: "05" },
    { value: "134", text: "CAMPAMENTO", main: "05" },
    { value: "138", text: "CAÑASGORDAS", main: "05" },
    { value: "142", text: "CARACOLI", main: "05" },
    { value: "145", text: "CARAMANTA", main: "05" },
    { value: "147", text: "CAREPA", main: "05" },
    { value: "148", text: "EL CARMEN DE VIBORAL", main: "05" },
    { value: "150", text: "CAROLINA", main: "05" },
    { value: "154", text: "CAUCASIA", main: "05" },
    { value: "172", text: "CHIGORODO", main: "05" },
    { value: "190", text: "CISNEROS", main: "05" },
    { value: "197", text: "COCORNA", main: "05" },
    { value: "206", text: "CONCEPCION", main: "05" },
    { value: "209", text: "CONCORDIA", main: "05" },
    { value: "212", text: "COPACABANA", main: "05" },
    { value: "234", text: "DABEIBA", main: "05" },
    { value: "237", text: "DON MATIAS", main: "05" },
    { value: "240", text: "EBEJICO", main: "05" },
    { value: "250", text: "EL BAGRE", main: "05" },
    { value: "264", text: "ENTRERRIOS", main: "05" },
    { value: "266", text: "ENVIGADO", main: "05" },
    { value: "282", text: "FREDONIA", main: "05" },
    { value: "284", text: "FRONTINO", main: "05" },
    { value: "306", text: "GIRALDO", main: "05" },
    { value: "308", text: "GIRARDOTA", main: "05" },
    { value: "310", text: "GOMEZ PLATA", main: "05" },
    { value: "313", text: "GRANADA", main: "05" },
    { value: "315", text: "GUADALUPE", main: "05" },
    { value: "318", text: "GUARNE", main: "05" },
    { value: "321", text: "GUATAPE", main: "05" },
    { value: "347", text: "HELICONIA", main: "05" },
    { value: "353", text: "HISPANIA", main: "05" },
    { value: "360", text: "ITAGUI", main: "05" },
    { value: "361", text: "ITUANGO", main: "05" },
    { value: "364", text: "JARDIN", main: "05" },
    { value: "368", text: "JERICO", main: "05" },
    { value: "376", text: "LA CEJA", main: "05" },
    { value: "380", text: "LA ESTRELLA", main: "05" },
    { value: "390", text: "LA PINTADA", main: "05" },
    { value: "400", text: "LA UNION", main: "05" },
    { value: "411", text: "LIBORINA", main: "05" },
    { value: "425", text: "MACEO", main: "05" },
    { value: "440", text: "MARINILLA", main: "05" },
    { value: "467", text: "MONTEBELLO", main: "05" },
    { value: "475", text: "MURINDO", main: "05" },
    { value: "480", text: "MUTATA", main: "05" },
    { value: "483", text: "NARIÑO", main: "05" },
    { value: "490", text: "NECOCLI", main: "05" },
    { value: "495", text: "NECHI", main: "05" },
    { value: "501", text: "OLAYA", main: "05" },
    { value: "541", text: "PEÐOL", main: "05" },
    { value: "543", text: "PEQUE", main: "05" },
    { value: "576", text: "PUEBLORRICO", main: "05" },
    { value: "579", text: "PUERTO BERRIO", main: "05" },
    { value: "585", text: "PUERTO NARE", main: "05" },
    { value: "591", text: "PUERTO TRIUNFO", main: "05" },
    { value: "604", text: "REMEDIOS", main: "05" },
    { value: "607", text: "RETIRO", main: "05" },
    { value: "615", text: "RIONEGRO", main: "05" },
    { value: "628", text: "SABANALARGA", main: "05" },
    { value: "631", text: "SABANETA", main: "05" },
    { value: "642", text: "SALGAR", main: "05" },
    { value: "647", text: "SAN ANDRES DE CUERQUIA", main: "05" },
    { value: "649", text: "SAN CARLOS", main: "05" },
    { value: "652", text: "SAN FRANCISCO", main: "05" },
    { value: "656", text: "SAN JERONIMO", main: "05" },
    { value: "658", text: "SAN JOSE DE LA MONTAÑA", main: "05" },
    { value: "659", text: "SAN JUAN DE URABA", main: "05" },
    { value: "660", text: "SAN LUIS", main: "05" },
    { value: "664", text: "SAN PEDRO", main: "05" },
    { value: "665", text: "SAN PEDRO DE URABA", main: "05" },
    { value: "667", text: "SAN RAFAEL", main: "05" },
    { value: "670", text: "SAN ROQUE", main: "05" },
    { value: "674", text: "SAN VICENTE", main: "05" },
    { value: "679", text: "SANTA BARBARA", main: "05" },
    { value: "686", text: "SANTA ROSA DE OSOS", main: "05" },
    { value: "690", text: "SANTO DOMINGO", main: "05" },
    { value: "697", text: "EL SANTUARIO", main: "05" },
    { value: "736", text: "SEGOVIA", main: "05" },
    { value: "756", text: "SONSON", main: "05" },
    { value: "761", text: "SOPETRAN", main: "05" },
    { value: "789", text: "TAMESIS", main: "05" },
    { value: "790", text: "TARAZA", main: "05" },
    { value: "792", text: "TARSO", main: "05" },
    { value: "809", text: "TITIRIBI", main: "05" },
    { value: "819", text: "TOLEDO", main: "05" },
    { value: "837", text: "TURBO", main: "05" },
    { value: "842", text: "URAMITA", main: "05" },
    { value: "847", text: "URRAO", main: "05" },
    { value: "854", text: "VALDIVIA", main: "05" },
    { value: "856", text: "VALPARAISO", main: "05" },
    { value: "858", text: "VEGACHI", main: "05" },
    { value: "861", text: "VENECIA", main: "05" },
    { value: "873", text: "VIGIA DEL FUERTE", main: "05" },
    { value: "885", text: "YALI", main: "05" },
    { value: "887", text: "YARUMAL", main: "05" },
    { value: "890", text: "YOLOMBO", main: "05" },
    { value: "893", text: "YONDO", main: "05" },
    { value: "895", text: "ZARAGOZA", main: "05" },
    { value: "001", text: "BARRANQUILLA", main: "08" },
    { value: "078", text: "BARANOA", main: "08" },
    { value: "137", text: "CAMPO DE LA CRUZ", main: "08" },
    { value: "141", text: "CANDELARIA", main: "08" },
    { value: "296", text: "GALAPA", main: "08" },
    { value: "372", text: "JUAN DE ACOSTA", main: "08" },
    { value: "421", text: "LURUACO", main: "08" },
    { value: "433", text: "MALAMBO", main: "08" },
    { value: "436", text: "MANATI", main: "08" },
    { value: "520", text: "PALMAR DE VARELA", main: "08" },
    { value: "549", text: "PIOJO", main: "08" },
    { value: "558", text: "POLONUEVO", main: "08" },
    { value: "560", text: "PONEDERA", main: "08" },
    { value: "573", text: "PUERTO COLOMBIA", main: "08" },
    { value: "606", text: "REPELON", main: "08" },
    { value: "634", text: "SABANAGRANDE", main: "08" },
    { value: "638", text: "SABANALARGA", main: "08" },
    { value: "675", text: "SANTA LUCIA", main: "08" },
    { value: "685", text: "SANTO TOMAS", main: "08" },
    { value: "758", text: "SOLEDAD", main: "08" },
    { value: "770", text: "SUAN", main: "08" },
    { value: "832", text: "TUBARA", main: "08" },
    { value: "849", text: "USIACURI", main: "08" },
    { value: "001", text: "BOGOTA, D.C.", main: "11" },
    { value: "001", text: "CARTAGENA", main: "13" },
    { value: "006", text: "ACHI", main: "13" },
    { value: "030", text: "ALTOS DEL ROSARIO", main: "13" },
    { value: "042", text: "ARENAL", main: "13" },
    { value: "052", text: "ARJONA", main: "13" },
    { value: "062", text: "ARROYOHONDO", main: "13" },
    { value: "074", text: "BARRANCO DE LOBA", main: "13" },
    { value: "140", text: "CALAMAR", main: "13" },
    { value: "160", text: "CANTAGALLO", main: "13" },
    { value: "188", text: "CICUCO", main: "13" },
    { value: "212", text: "CORDOBA", main: "13" },
    { value: "222", text: "CLEMENCIA", main: "13" },
    { value: "244", text: "EL CARMEN DE BOLIVAR", main: "13" },
    { value: "248", text: "EL GUAMO", main: "13" },
    { value: "268", text: "EL PEÑON", main: "13" },
    { value: "300", text: "HATILLO DE LOBA", main: "13" },
    { value: "430", text: "MAGANGUE", main: "13" },
    { value: "433", text: "MAHATES", main: "13" },
    { value: "440", text: "MARGARITA", main: "13" },
    { value: "442", text: "MARIA LA BAJA", main: "13" },
    { value: "458", text: "MONTECRISTO", main: "13" },
    { value: "468", text: "MOMPOS", main: "13" },
    { value: "490", text: "NOROSI", main: "13" },
    { value: "473", text: "MORALES", main: "13" },
    { value: "549", text: "PINILLOS", main: "13" },
    { value: "580", text: "REGIDOR", main: "13" },
    { value: "600", text: "RIO VIEJO", main: "13" },
    { value: "620", text: "SAN CRISTOBAL", main: "13" },
    { value: "647", text: "SAN ESTANISLAO", main: "13" },
    { value: "650", text: "SAN FERNANDO", main: "13" },
    { value: "654", text: "SAN JACINTO", main: "13" },
    { value: "655", text: "SAN JACINTO DEL CAUCA", main: "13" },
    { value: "657", text: "SAN JUAN NEPOMUCENO", main: "13" },
    { value: "667", text: "SAN MARTIN DE LOBA", main: "13" },
    { value: "670", text: "SAN PABLO", main: "13" },
    { value: "673", text: "SANTA CATALINA", main: "13" },
    { value: "683", text: "SANTA ROSA", main: "13" },
    { value: "688", text: "SANTA ROSA DEL SUR", main: "13" },
    { value: "744", text: "SIMITI", main: "13" },
    { value: "760", text: "SOPLAVIENTO", main: "13" },
    { value: "780", text: "TALAIGUA NUEVO", main: "13" },
    { value: "810", text: "TIQUISIO", main: "13" },
    { value: "836", text: "TURBACO", main: "13" },
    { value: "838", text: "TURBANA", main: "13" },
    { value: "873", text: "VILLANUEVA", main: "13" },
    { value: "894", text: "ZAMBRANO", main: "13" },
    { value: "001", text: "TUNJA", main: "15" },
    { value: "022", text: "ALMEIDA", main: "15" },
    { value: "047", text: "AQUITANIA", main: "15" },
    { value: "051", text: "ARCABUCO", main: "15" },
    { value: "087", text: "BELEN", main: "15" },
    { value: "090", text: "BERBEO", main: "15" },
    { value: "092", text: "BETEITIVA", main: "15" },
    { value: "097", text: "BOAVITA", main: "15" },
    { value: "104", text: "BOYACA", main: "15" },
    { value: "106", text: "BRICEÑO", main: "15" },
    { value: "109", text: "BUENAVISTA", main: "15" },
    { value: "114", text: "BUSBANZA", main: "15" },
    { value: "131", text: "CALDAS", main: "15" },
    { value: "135", text: "CAMPOHERMOSO", main: "15" },
    { value: "162", text: "CERINZA", main: "15" },
    { value: "172", text: "CHINAVITA", main: "15" },
    { value: "176", text: "CHIQUINQUIRA", main: "15" },
    { value: "180", text: "CHISCAS", main: "15" },
    { value: "183", text: "CHITA", main: "15" },
    { value: "185", text: "CHITARAQUE", main: "15" },
    { value: "187", text: "CHIVATA", main: "15" },
    { value: "189", text: "CIENEGA", main: "15" },
    { value: "204", text: "COMBITA", main: "15" },
    { value: "212", text: "COPER", main: "15" },
    { value: "215", text: "CORRALES", main: "15" },
    { value: "218", text: "COVARACHIA", main: "15" },
    { value: "223", text: "CUBARA", main: "15" },
    { value: "224", text: "CUCAITA", main: "15" },
    { value: "226", text: "CUITIVA", main: "15" },
    { value: "232", text: "CHIQUIZA", main: "15" },
    { value: "236", text: "CHIVOR", main: "15" },
    { value: "238", text: "DUITAMA", main: "15" },
    { value: "244", text: "EL COCUY", main: "15" },
    { value: "248", text: "EL ESPINO", main: "15" },
    { value: "272", text: "FIRAVITOBA", main: "15" },
    { value: "276", text: "FLORESTA", main: "15" },
    { value: "293", text: "GACHANTIVA", main: "15" },
    { value: "296", text: "GAMEZA", main: "15" },
    { value: "299", text: "GARAGOA", main: "15" },
    { value: "317", text: "GUACAMAYAS", main: "15" },
    { value: "322", text: "GUATEQUE", main: "15" },
    { value: "325", text: "GUAYATA", main: "15" },
    { value: "332", text: "GsICAN", main: "15" },
    { value: "362", text: "IZA", main: "15" },
    { value: "367", text: "JENESANO", main: "15" },
    { value: "368", text: "JERICO", main: "15" },
    { value: "377", text: "LABRANZAGRANDE", main: "15" },
    { value: "380", text: "LA CAPILLA", main: "15" },
    { value: "401", text: "LA VICTORIA", main: "15" },
    { value: "403", text: "LA UVITA", main: "15" },
    { value: "407", text: "VILLA DE LEYVA", main: "15" },
    { value: "425", text: "MACANAL", main: "15" },
    { value: "442", text: "MARIPI", main: "15" },
    { value: "455", text: "MIRAFLORES", main: "15" },
    { value: "464", text: "MONGUA", main: "15" },
    { value: "466", text: "MONGUI", main: "15" },
    { value: "469", text: "MONIQUIRA", main: "15" },
    { value: "476", text: "MOTAVITA", main: "15" },
    { value: "480", text: "MUZO", main: "15" },
    { value: "491", text: "NOBSA", main: "15" },
    { value: "494", text: "NUEVO COLON", main: "15" },
    { value: "500", text: "OICATA", main: "15" },
    { value: "507", text: "OTANCHE", main: "15" },
    { value: "511", text: "PACHAVITA", main: "15" },
    { value: "514", text: "PAEZ", main: "15" },
    { value: "516", text: "PAIPA", main: "15" },
    { value: "518", text: "PAJARITO", main: "15" },
    { value: "522", text: "PANQUEBA", main: "15" },
    { value: "531", text: "PAUNA", main: "15" },
    { value: "533", text: "PAYA", main: "15" },
    { value: "537", text: "PAZ DE RIO", main: "15" },
    { value: "542", text: "PESCA", main: "15" },
    { value: "550", text: "PISBA", main: "15" },
    { value: "572", text: "PUERTO BOYACA", main: "15" },
    { value: "580", text: "QUIPAMA", main: "15" },
    { value: "599", text: "RAMIRIQUI", main: "15" },
    { value: "600", text: "RAQUIRA", main: "15" },
    { value: "621", text: "RONDON", main: "15" },
    { value: "632", text: "SABOYA", main: "15" },
    { value: "638", text: "SACHICA", main: "15" },
    { value: "646", text: "SAMACA", main: "15" },
    { value: "660", text: "SAN EDUARDO", main: "15" },
    { value: "664", text: "SAN JOSE DE PARE", main: "15" },
    { value: "667", text: "SAN LUIS DE GACENO", main: "15" },
    { value: "673", text: "SAN MATEO", main: "15" },
    { value: "676", text: "SAN MIGUEL DE SEMA", main: "15" },
    { value: "681", text: "SAN PABLO DE BORBUR", main: "15" },
    { value: "686", text: "SANTANA", main: "15" },
    { value: "690", text: "SANTA MARIA", main: "15" },
    { value: "693", text: "SANTA ROSA DE VITERBO", main: "15" },
    { value: "696", text: "SANTA SOFIA", main: "15" },
    { value: "720", text: "SATIVANORTE", main: "15" },
    { value: "723", text: "SATIVASUR", main: "15" },
    { value: "740", text: "SIACHOQUE", main: "15" },
    { value: "753", text: "SOATA", main: "15" },
    { value: "755", text: "SOCOTA", main: "15" },
    { value: "757", text: "SOCHA", main: "15" },
    { value: "759", text: "SOGAMOSO", main: "15" },
    { value: "761", text: "SOMONDOCO", main: "15" },
    { value: "762", text: "SORA", main: "15" },
    { value: "763", text: "SOTAQUIRA", main: "15" },
    { value: "764", text: "SORACA", main: "15" },
    { value: "774", text: "SUSACON", main: "15" },
    { value: "776", text: "SUTAMARCHAN", main: "15" },
    { value: "778", text: "SUTATENZA", main: "15" },
    { value: "790", text: "TASCO", main: "15" },
    { value: "798", text: "TENZA", main: "15" },
    { value: "804", text: "TIBANA", main: "15" },
    { value: "806", text: "TIBASOSA", main: "15" },
    { value: "808", text: "TINJACA", main: "15" },
    { value: "810", text: "TIPACOQUE", main: "15" },
    { value: "814", text: "TOCA", main: "15" },
    { value: "816", text: "TOGsI", main: "15" },
    { value: "820", text: "TOPAGA", main: "15" },
    { value: "822", text: "TOTA", main: "15" },
    { value: "832", text: "TUNUNGUA", main: "15" },
    { value: "835", text: "TURMEQUE", main: "15" },
    { value: "837", text: "TUTA", main: "15" },
    { value: "839", text: "TUTAZA", main: "15" },
    { value: "842", text: "UMBITA", main: "15" },
    { value: "861", text: "VENTAQUEMADA", main: "15" },
    { value: "879", text: "VIRACACHA", main: "15" },
    { value: "897", text: "ZETAQUIRA", main: "15" },
    { value: "1", text: "MANIZALES", main: "17" },
    { value: "13", text: "AGUADAS", main: "17" },
    { value: "42", text: "ANSERMA", main: "17" },
    { value: "50", text: "ARANZAZU", main: "17" },
    { value: "88", text: "BELALCAZAR", main: "17" },
    { value: "174", text: "CHINCHINA", main: "17" },
    { value: "272", text: "FILADELFIA", main: "17" },
    { value: "380", text: "LA DORADA", main: "17" },
    { value: "388", text: "LA MERCED", main: "17" },
    { value: "433", text: "MANZANARES", main: "17" },
    { value: "442", text: "MARMATO", main: "17" },
    { value: "444", text: "MARQUETALIA", main: "17" },
    { value: "446", text: "MARULANDA", main: "17" },
    { value: "486", text: "NEIRA", main: "17" },
    { value: "495", text: "NORCASIA", main: "17" },
    { value: "513", text: "PACORA", main: "17" },
    { value: "524", text: "PALESTINA", main: "17" },
    { value: "541", text: "PENSILVANIA", main: "17" },
    { value: "614", text: "RIOSUCIO", main: "17" },
    { value: "616", text: "RISARALDA", main: "17" },
    { value: "653", text: "SALAMINA", main: "17" },
    { value: "662", text: "SAMANA", main: "17" },
    { value: "665", text: "SAN JOSE", main: "17" },
    { value: "777", text: "SUPIA", main: "17" },
    { value: "867", text: "VICTORIA", main: "17" },
    { value: "873", text: "VILLAMARIA", main: "17" },
    { value: "877", text: "VITERBO", main: "17" },
    { value: "1", text: "FLORENCIA", main: "18" },
    { value: "29", text: "ALBANIA", main: "18" },
    { value: "94", text: "BELEN DE LOS ANDAQUIES", main: "18" },
    { value: "150", text: "CARTAGENA DEL CHAIRA", main: "18" },
    { value: "205", text: "CURILLO", main: "18" },
    { value: "247", text: "EL DONCELLO", main: "18" },
    { value: "256", text: "EL PAUJIL", main: "18" },
    { value: "410", text: "LA MONTAÑITA", main: "18" },
    { value: "460", text: "MILAN", main: "18" },
    { value: "479", text: "MORELIA", main: "18" },
    { value: "592", text: "PUERTO RICO", main: "18" },
    { value: "610", text: "SAN JOSE DEL FRAGUA", main: "18" },
    { value: "753", text: "SAN VICENTE DEL CAGUAN", main: "18" },
    { value: "756", text: "SOLANO", main: "18" },
    { value: "785", text: "SOLITA", main: "18" },
    { value: "860", text: "VALPARAISO", main: "18" },
    { value: "1", text: "POPAYAN", main: "19" },
    { value: "22", text: "ALMAGUER", main: "19" },
    { value: "50", text: "ARGELIA", main: "19" },
    { value: "75", text: "BALBOA", main: "19" },
    { value: "100", text: "BOLIVAR", main: "19" },
    { value: "110", text: "BUENOS AIRES", main: "19" },
    { value: "130", text: "CAJIBIO", main: "19" },
    { value: "137", text: "CALDONO", main: "19" },
    { value: "142", text: "CALOTO", main: "19" },
    { value: "212", text: "CORINTO", main: "19" },
    { value: "256", text: "EL TAMBO", main: "19" },
    { value: "290", text: "FLORENCIA", main: "19" },
    { value: "300", text: "GUACHENE", main: "19" },
    { value: "318", text: "GUAPI", main: "19" },
    { value: "355", text: "INZA", main: "19" },
    { value: "364", text: "JAMBALO", main: "19" },
    { value: "392", text: "LA SIERRA", main: "19" },
    { value: "397", text: "LA VEGA", main: "19" },
    { value: "418", text: "LOPEZ", main: "19" },
    { value: "450", text: "MERCADERES", main: "19" },
    { value: "455", text: "MIRANDA", main: "19" },
    { value: "473", text: "MORALES", main: "19" },
    { value: "513", text: "PADILLA", main: "19" },
    { value: "517", text: "PAEZ", main: "19" },
    { value: "532", text: "PATIA", main: "19" },
    { value: "533", text: "PIAMONTE", main: "19" },
    { value: "548", text: "PIENDAMO", main: "19" },
    { value: "573", text: "PUERTO TEJADA", main: "19" },
    { value: "585", text: "PURACE", main: "19" },
    { value: "622", text: "ROSAS", main: "19" },
    { value: "693", text: "SAN SEBASTIAN", main: "19" },
    { value: "698", text: "SANTANDER DE QUILICHAO", main: "19" },
    { value: "701", text: "SANTA ROSA", main: "19" },
    { value: "743", text: "SILVIA", main: "19" },
    { value: "760", text: "SOTARA", main: "19" },
    { value: "780", text: "SUAREZ", main: "19" },
    { value: "785", text: "SUCRE", main: "19" },
    { value: "807", text: "TIMBIO", main: "19" },
    { value: "809", text: "TIMBIQUI", main: "19" },
    { value: "821", text: "TORIBIO", main: "19" },
    { value: "824", text: "TOTORO", main: "19" },
    { value: "845", text: "VILLA RICA", main: "19" },
    { value: "001", text: "VALLEDUPAR", main: "20" },
    { value: "011", text: "AGUACHICA", main: "20" },
    { value: "013", text: "AGUSTIN CODAZZI", main: "20" },
    { value: "032", text: "ASTREA", main: "20" },
    { value: "045", text: "BECERRIL", main: "20" },
    { value: "060", text: "BOSCONIA", main: "20" },
    { value: "175", text: "CHIMICHAGUA", main: "20" },
    { value: "178", text: "CHIRIGUANA", main: "20" },
    { value: "228", text: "CURUMANI", main: "20" },
    { value: "238", text: "EL COPEY", main: "20" },
    { value: "250", text: "EL PASO", main: "20" },
    { value: "295", text: "GAMARRA", main: "20" },
    { value: "310", text: "GONZALEZ", main: "20" },
    { value: "383", text: "LA GLORIA", main: "20" },
    { value: "400", text: "LA JAGUA DE IBIRICO", main: "20" },
    { value: "443", text: "MANAURE", main: "20" },
    { value: "517", text: "PAILITAS", main: "20" },
    { value: "550", text: "PELAYA", main: "20" },
    { value: "570", text: "PUEBLO BELLO", main: "20" },
    { value: "614", text: "RIO DE ORO", main: "20" },
    { value: "621", text: "LA PAZ", main: "20" },
    { value: "710", text: "SAN ALBERTO", main: "20" },
    { value: "750", text: "SAN DIEGO", main: "20" },
    { value: "770", text: "SAN MARTIN", main: "20" },
    { value: "787", text: "TAMALAMEQUE", main: "20" },
    { value: "1", text: "MONTERIA", main: "23" },
    { value: "68", text: "AYAPEL", main: "23" },
    { value: "79", text: "BUENAVISTA", main: "23" },
    { value: "90", text: "CANALETE", main: "23" },
    { value: "162", text: "CERETE", main: "23" },
    { value: "168", text: "CHIMA", main: "23" },
    { value: "182", text: "CHINU", main: "23" },
    { value: "189", text: "CIENAGA DE ORO", main: "23" },
    { value: "300", text: "COTORRA", main: "23" },
    { value: "350", text: "LA APARTADA", main: "23" },
    { value: "417", text: "LORICA", main: "23" },
    { value: "419", text: "LOS CORDOBAS", main: "23" },
    { value: "464", text: "MOMIL", main: "23" },
    { value: "466", text: "MONTELIBANO", main: "23" },
    { value: "500", text: "MOÑITOS", main: "23" },
    { value: "555", text: "PLANETA RICA", main: "23" },
    { value: "570", text: "PUEBLO NUEVO", main: "23" },
    { value: "574", text: "PUERTO ESCONDIDO", main: "23" },
    { value: "580", text: "PUERTO LIBERTADOR", main: "23" },
    { value: "586", text: "PURISIMA", main: "23" },
    { value: "660", text: "SAHAGUN", main: "23" },
    { value: "670", text: "SAN ANDRES SOTAVENTO", main: "23" },
    { value: "672", text: "SAN ANTERO", main: "23" },
    { value: "675", text: "SAN BERNARDO DEL VIENTO", main: "23" },
    { value: "678", text: "SAN CARLOS", main: "23" },
    { value: "686", text: "SAN PELAYO", main: "23" },
    { value: "807", text: "TIERRALTA", main: "23" },
    { value: "855", text: "VALENCIA", main: "23" },
    { value: "001", text: "AGUA DE DIOS", main: "25" },
    { value: "019", text: "ALBAN", main: "25" },
    { value: "035", text: "ANAPOIMA", main: "25" },
    { value: "040", text: "ANOLAIMA", main: "25" },
    { value: "053", text: "ARBELAEZ", main: "25" },
    { value: "086", text: "BELTRAN", main: "25" },
    { value: "095", text: "BITUIMA", main: "25" },
    { value: "099", text: "BOJACA", main: "25" },
    { value: "120", text: "CABRERA", main: "25" },
    { value: "123", text: "CACHIPAY", main: "25" },
    { value: "126", text: "CAJICA", main: "25" },
    { value: "148", text: "CAPARRAPI", main: "25" },
    { value: "151", text: "CAQUEZA", main: "25" },
    { value: "154", text: "CARMEN DE CARUPA", main: "25" },
    { value: "168", text: "CHAGUANI", main: "25" },
    { value: "175", text: "CHIA", main: "25" },
    { value: "178", text: "CHIPAQUE", main: "25" },
    { value: "181", text: "CHOACHI", main: "25" },
    { value: "183", text: "CHOCONTA", main: "25" },
    { value: "200", text: "COGUA", main: "25" },
    { value: "214", text: "COTA", main: "25" },
    { value: "224", text: "CUCUNUBA", main: "25" },
    { value: "245", text: "EL COLEGIO", main: "25" },
    { value: "258", text: "EL PEÑON", main: "25" },
    { value: "260", text: "EL ROSAL", main: "25" },
    { value: "269", text: "FACATATIVA", main: "25" },
    { value: "279", text: "FOMEQUE", main: "25" },
    { value: "281", text: "FOSCA", main: "25" },
    { value: "286", text: "FUNZA", main: "25" },
    { value: "288", text: "FUQUENE", main: "25" },
    { value: "290", text: "FUSAGASUGA", main: "25" },
    { value: "293", text: "GACHALA", main: "25" },
    { value: "295", text: "GACHANCIPA", main: "25" },
    { value: "297", text: "GACHETA", main: "25" },
    { value: "299", text: "GAMA", main: "25" },
    { value: "307", text: "GIRARDOT", main: "25" },
    { value: "312", text: "GRANADA", main: "25" },
    { value: "317", text: "GUACHETA", main: "25" },
    { value: "320", text: "GUADUAS", main: "25" },
    { value: "322", text: "GUASCA", main: "25" },
    { value: "324", text: "GUATAQUI", main: "25" },
    { value: "326", text: "GUATAVITA", main: "25" },
    { value: "328", text: "GUAYABAL DE SIQUIMA", main: "25" },
    { value: "335", text: "GUAYABETAL", main: "25" },
    { value: "339", text: "GUTIERREZ", main: "25" },
    { value: "368", text: "JERUSALEN", main: "25" },
    { value: "372", text: "JUNIN", main: "25" },
    { value: "377", text: "LA CALERA", main: "25" },
    { value: "386", text: "LA MESA", main: "25" },
    { value: "394", text: "LA PALMA", main: "25" },
    { value: "398", text: "LA PEÑA", main: "25" },
    { value: "402", text: "LA VEGA", main: "25" },
    { value: "407", text: "LENGUAZAQUE", main: "25" },
    { value: "426", text: "MACHETA", main: "25" },
    { value: "430", text: "MADRID", main: "25" },
    { value: "436", text: "MANTA", main: "25" },
    { value: "438", text: "MEDINA", main: "25" },
    { value: "473", text: "MOSQUERA", main: "25" },
    { value: "483", text: "NARIÑO", main: "25" },
    { value: "486", text: "NEMOCON", main: "25" },
    { value: "488", text: "NILO", main: "25" },
    { value: "489", text: "NIMAIMA", main: "25" },
    { value: "491", text: "NOCAIMA", main: "25" },
    { value: "506", text: "VENECIA", main: "25" },
    { value: "513", text: "PACHO", main: "25" },
    { value: "518", text: "PAIME", main: "25" },
    { value: "524", text: "PANDI", main: "25" },
    { value: "530", text: "PARATEBUENO", main: "25" },
    { value: "535", text: "PASCA", main: "25" },
    { value: "572", text: "PUERTO SALGAR", main: "25" },
    { value: "580", text: "PULI", main: "25" },
    { value: "592", text: "QUEBRADANEGRA", main: "25" },
    { value: "594", text: "QUETAME", main: "25" },
    { value: "596", text: "QUIPILE", main: "25" },
    { value: "599", text: "APULO", main: "25" },
    { value: "612", text: "RICAURTE", main: "25" },
    { value: "645", text: "SAN ANTONIO DEL TEQUENDAMA", main: "25" },
    { value: "649", text: "SAN BERNARDO", main: "25" },
    { value: "653", text: "SAN CAYETANO", main: "25" },
    { value: "658", text: "SAN FRANCISCO", main: "25" },
    { value: "662", text: "SAN JUAN DE RIO SECO", main: "25" },
    { value: "718", text: "SASAIMA", main: "25" },
    { value: "736", text: "SESQUILE", main: "25" },
    { value: "740", text: "SIBATE", main: "25" },
    { value: "743", text: "SILVANIA", main: "25" },
    { value: "745", text: "SIMIJACA", main: "25" },
    { value: "754", text: "SOACHA", main: "25" },
    { value: "758", text: "SOPO", main: "25" },
    { value: "769", text: "SUBACHOQUE", main: "25" },
    { value: "772", text: "SUESCA", main: "25" },
    { value: "777", text: "SUPATA", main: "25" },
    { value: "779", text: "SUSA", main: "25" },
    { value: "781", text: "SUTATAUSA", main: "25" },
    { value: "785", text: "TABIO", main: "25" },
    { value: "793", text: "TAUSA", main: "25" },
    { value: "797", text: "TENA", main: "25" },
    { value: "799", text: "TENJO", main: "25" },
    { value: "805", text: "TIBACUY", main: "25" },
    { value: "807", text: "TIBIRITA", main: "25" },
    { value: "815", text: "TOCAIMA", main: "25" },
    { value: "817", text: "TOCANCIPA", main: "25" },
    { value: "823", text: "TOPAIPI", main: "25" },
    { value: "839", text: "UBALA", main: "25" },
    { value: "841", text: "UBAQUE", main: "25" },
    { value: "843", text: "VILLA DE SAN DIEGO DE UBATE", main: "25" },
    { value: "845", text: "UNE", main: "25" },
    { value: "851", text: "UTICA", main: "25" },
    { value: "862", text: "VERGARA", main: "25" },
    { value: "867", text: "VIANI", main: "25" },
    { value: "871", text: "VILLAGOMEZ", main: "25" },
    { value: "873", text: "VILLAPINZON", main: "25" },
    { value: "875", text: "VILLETA", main: "25" },
    { value: "878", text: "VIOTA", main: "25" },
    { value: "885", text: "YACOPI", main: "25" },
    { value: "898", text: "ZIPACON", main: "25" },
    { value: "899", text: "ZIPAQUIRA", main: "25" },
    { value: "1", text: "QUIBDO", main: "27" },
    { value: "6", text: "ACANDI", main: "27" },
    { value: "25", text: "ALTO BAUDO", main: "27" },
    { value: "50", text: "ATRATO", main: "27" },
    { value: "73", text: "BAGADO", main: "27" },
    { value: "75", text: "BAHIA SOLANO", main: "27" },
    { value: "77", text: "BAJO BAUDO", main: "27" },
    { value: "99", text: "BOJAYA", main: "27" },
    { value: "135", text: "EL CANTON DEL SAN PABLO", main: "27" },
    { value: "150", text: "CARMEN DEL DARIEN", main: "27" },
    { value: "160", text: "CERTEGUI", main: "27" },
    { value: "205", text: "CONDOTO", main: "27" },
    { value: "245", text: "EL CARMEN DE ATRATO", main: "27" },
    { value: "250", text: "EL LITORAL DEL SAN JUAN", main: "27" },
    { value: "361", text: "ISTMINA", main: "27" },
    { value: "372", text: "JURADO", main: "27" },
    { value: "413", text: "LLORO", main: "27" },
    { value: "425", text: "MEDIO ATRATO", main: "27" },
    { value: "430", text: "MEDIO BAUDO", main: "27" },
    { value: "450", text: "MEDIO SAN JUAN", main: "27" },
    { value: "491", text: "NOVITA", main: "27" },
    { value: "495", text: "NUQUI", main: "27" },
    { value: "580", text: "RIO IRO", main: "27" },
    { value: "600", text: "RIO QUITO", main: "27" },
    { value: "615", text: "RIOSUCIO", main: "27" },
    { value: "660", text: "SAN JOSE DEL PALMAR", main: "27" },
    { value: "745", text: "SIPI", main: "27" },
    { value: "787", text: "TADO", main: "27" },
    { value: "800", text: "UNGUIA", main: "27" },
    { value: "810", text: "UNION PANAMERICANA", main: "27" },
    { value: "001", text: "NEIVA", main: "41" },
    { value: "006", text: "ACEVEDO", main: "41" },
    { value: "013", text: "AGRADO", main: "41" },
    { value: "016", text: "AIPE", main: "41" },
    { value: "020", text: "ALGECIRAS", main: "41" },
    { value: "026", text: "ALTAMIRA", main: "41" },
    { value: "078", text: "BARAYA", main: "41" },
    { value: "132", text: "CAMPOALEGRE", main: "41" },
    { value: "206", text: "COLOMBIA", main: "41" },
    { value: "244", text: "ELIAS", main: "41" },
    { value: "298", text: "GARZON", main: "41" },
    { value: "306", text: "GIGANTE", main: "41" },
    { value: "319", text: "GUADALUPE", main: "41" },
    { value: "349", text: "HOBO", main: "41" },
    { value: "357", text: "IQUIRA", main: "41" },
    { value: "359", text: "ISNOS", main: "41" },
    { value: "378", text: "LA ARGENTINA", main: "41" },
    { value: "396", text: "LA PLATA", main: "41" },
    { value: "483", text: "NATAGA", main: "41" },
    { value: "503", text: "OPORAPA", main: "41" },
    { value: "518", text: "PAICOL", main: "41" },
    { value: "524", text: "PALERMO", main: "41" },
    { value: "530", text: "PALESTINA", main: "41" },
    { value: "548", text: "PITAL", main: "41" },
    { value: "551", text: "PITALITO", main: "41" },
    { value: "615", text: "RIVERA", main: "41" },
    { value: "660", text: "SALADOBLANCO", main: "41" },
    { value: "668", text: "SAN AGUSTIN", main: "41" },
    { value: "676", text: "SANTA MARIA", main: "41" },
    { value: "770", text: "SUAZA", main: "41" },
    { value: "791", text: "TARQUI", main: "41" },
    { value: "797", text: "TESALIA", main: "41" },
    { value: "799", text: "TELLO", main: "41" },
    { value: "801", text: "TERUEL", main: "41" },
    { value: "807", text: "TIMANA", main: "41" },
    { value: "872", text: "VILLAVIEJA", main: "41" },
    { value: "885", text: "YAGUARA", main: "41" },
    { value: "001", text: "RIOHACHA", main: "44" },
    { value: "035", text: "ALBANIA", main: "44" },
    { value: "078", text: "BARRANCAS", main: "44" },
    { value: "090", text: "DIBULLA", main: "44" },
    { value: "098", text: "DISTRACCION", main: "44" },
    { value: "110", text: "EL MOLINO", main: "44" },
    { value: "279", text: "FONSECA", main: "44" },
    { value: "378", text: "HATONUEVO", main: "44" },
    { value: "420", text: "LA JAGUA DEL PILAR", main: "44" },
    { value: "430", text: "MAICAO", main: "44" },
    { value: "560", text: "MANAURE", main: "44" },
    { value: "650", text: "SAN JUAN DEL CESAR", main: "44" },
    { value: "847", text: "URIBIA", main: "44" },
    { value: "855", text: "URUMITA", main: "44" },
    { value: "874", text: "VILLANUEVA", main: "44" },
    { value: "001", text: "SANTA MARTA", main: "47" },
    { value: "030", text: "ALGARROBO", main: "47" },
    { value: "053", text: "ARACATACA", main: "47" },
    { value: "058", text: "ARIGUANI", main: "47" },
    { value: "161", text: "CERRO SAN ANTONIO", main: "47" },
    { value: "170", text: "CHIBOLO", main: "47" },
    { value: "189", text: "CIENAGA", main: "47" },
    { value: "205", text: "CONCORDIA", main: "47" },
    { value: "245", text: "EL BANCO", main: "47" },
    { value: "258", text: "EL PIÑON", main: "47" },
    { value: "268", text: "EL RETEN", main: "47" },
    { value: "288", text: "FUNDACION", main: "47" },
    { value: "318", text: "GUAMAL", main: "47" },
    { value: "460", text: "NUEVA GRANADA", main: "47" },
    { value: "541", text: "PEDRAZA", main: "47" },
    { value: "545", text: "PIJIÑO DEL CARMEN", main: "47" },
    { value: "551", text: "PIVIJAY", main: "47" },
    { value: "555", text: "PLATO", main: "47" },
    { value: "570", text: "PUEBLOVIEJO", main: "47" },
    { value: "605", text: "REMOLINO", main: "47" },
    { value: "660", text: "SABANAS DE SAN ANGEL", main: "47" },
    { value: "675", text: "SALAMINA", main: "47" },
    { value: "692", text: "SAN SEBASTIAN DE BUENAVISTA", main: "47" },
    { value: "703", text: "SAN ZENON", main: "47" },
    { value: "707", text: "SANTA ANA", main: "47" },
    { value: "720", text: "SANTA BARBARA DE PINTO", main: "47" },
    { value: "745", text: "SITIONUEVO", main: "47" },
    { value: "798", text: "TENERIFE", main: "47" },
    { value: "960", text: "ZAPAYAN", main: "47" },
    { value: "980", text: "ZONA BANANERA", main: "47" },
    { value: "001", text: "VILLAVICENCIO", main: "50" },
    { value: "006", text: "ACACIAS", main: "50" },
    { value: "110", text: "BARRANCA DE UPIA", main: "50" },
    { value: "124", text: "CABUYARO", main: "50" },
    { value: "150", text: "CASTILLA LA NUEVA", main: "50" },
    { value: "223", text: "CUBARRAL", main: "50" },
    { value: "226", text: "CUMARAL", main: "50" },
    { value: "245", text: "EL CALVARIO", main: "50" },
    { value: "251", text: "EL CASTILLO", main: "50" },
    { value: "270", text: "EL DORADO", main: "50" },
    { value: "287", text: "FUENTE DE ORO", main: "50" },
    { value: "313", text: "GRANADA", main: "50" },
    { value: "318", text: "GUAMAL", main: "50" },
    { value: "325", text: "MAPIRIPAN", main: "50" },
    { value: "330", text: "MESETAS", main: "50" },
    { value: "350", text: "LA MACARENA", main: "50" },
    { value: "370", text: "URIBE", main: "50" },
    { value: "400", text: "LEJANIAS", main: "50" },
    { value: "450", text: "PUERTO CONCORDIA", main: "50" },
    { value: "568", text: "PUERTO GAITAN", main: "50" },
    { value: "573", text: "PUERTO LOPEZ", main: "50" },
    { value: "577", text: "PUERTO LLERAS", main: "50" },
    { value: "590", text: "PUERTO RICO", main: "50" },
    { value: "606", text: "RESTREPO", main: "50" },
    { value: "680", text: "SAN CARLOS DE GUAROA", main: "50" },
    { value: "683", text: "SAN JUAN DE ARAMA", main: "50" },
    { value: "686", text: "SAN JUANITO", main: "50" },
    { value: "689", text: "SAN MARTIN", main: "50" },
    { value: "711", text: "VISTAHERMOSA", main: "50" },
    { value: "001", text: "PASTO", main: "52" },
    { value: "019", text: "ALBAN", main: "52" },
    { value: "022", text: "ALDANA", main: "52" },
    { value: "036", text: "ANCUYA", main: "52" },
    { value: "051", text: "ARBOLEDA", main: "52" },
    { value: "079", text: "BARBACOAS", main: "52" },
    { value: "083", text: "BELEN", main: "52" },
    { value: "110", text: "BUESACO", main: "52" },
    { value: "203", text: "COLON", main: "52" },
    { value: "207", text: "CONSACA", main: "52" },
    { value: "210", text: "CONTADERO", main: "52" },
    { value: "215", text: "CORDOBA", main: "52" },
    { value: "224", text: "CUASPUD", main: "52" },
    { value: "227", text: "CUMBAL", main: "52" },
    { value: "233", text: "CUMBITARA", main: "52" },
    { value: "240", text: "CHACHAGsI", main: "52" },
    { value: "250", text: "EL CHARCO", main: "52" },
    { value: "254", text: "EL PEÑOL", main: "52" },
    { value: "256", text: "EL ROSARIO", main: "52" },
    { value: "258", text: "EL TABLON DE GOMEZ", main: "52" },
    { value: "260", text: "EL TAMBO", main: "52" },
    { value: "287", text: "FUNES", main: "52" },
    { value: "317", text: "GUACHUCAL", main: "52" },
    { value: "320", text: "GUAITARILLA", main: "52" },
    { value: "323", text: "GUALMATAN", main: "52" },
    { value: "352", text: "ILES", main: "52" },
    { value: "354", text: "IMUES", main: "52" },
    { value: "356", text: "IPIALES", main: "52" },
    { value: "378", text: "LA CRUZ", main: "52" },
    { value: "381", text: "LA FLORIDA", main: "52" },
    { value: "385", text: "LA LLANADA", main: "52" },
    { value: "390", text: "LA TOLA", main: "52" },
    { value: "399", text: "LA UNION", main: "52" },
    { value: "405", text: "LEIVA", main: "52" },
    { value: "411", text: "LINARES", main: "52" },
    { value: "418", text: "LOS ANDES", main: "52" },
    { value: "427", text: "MAGsI", main: "52" },
    { value: "435", text: "MALLAMA", main: "52" },
    { value: "473", text: "MOSQUERA", main: "52" },
    { value: "480", text: "NARIÑO", main: "52" },
    { value: "490", text: "OLAYA HERRERA", main: "52" },
    { value: "506", text: "OSPINA", main: "52" },
    { value: "520", text: "FRANCISCO PIZARRO", main: "52" },
    { value: "540", text: "POLICARPA", main: "52" },
    { value: "560", text: "POTOSI", main: "52" },
    { value: "565", text: "PROVIDENCIA", main: "52" },
    { value: "573", text: "PUERRES", main: "52" },
    { value: "585", text: "PUPIALES", main: "52" },
    { value: "612", text: "RICAURTE", main: "52" },
    { value: "621", text: "ROBERTO PAYAN", main: "52" },
    { value: "678", text: "SAMANIEGO", main: "52" },
    { value: "683", text: "SANDONA", main: "52" },
    { value: "685", text: "SAN BERNARDO", main: "52" },
    { value: "687", text: "SAN LORENZO", main: "52" },
    { value: "693", text: "SAN PABLO", main: "52" },
    { value: "694", text: "SAN PEDRO DE CARTAGO", main: "52" },
    { value: "696", text: "SANTA BARBARA", main: "52" },
    { value: "699", text: "SANTACRUZ", main: "52" },
    { value: "720", text: "SAPUYES", main: "52" },
    { value: "786", text: "TAMINANGO", main: "52" },
    { value: "788", text: "TANGUA", main: "52" },
    { value: "835", text: "SAN ANDRES DE TUMACO", main: "52" },
    { value: "838", text: "TUQUERRES", main: "52" },
    { value: "885", text: "YACUANQUER", main: "52" },
    { value: "001", text: "CUCUTA", main: "54" },
    { value: "003", text: "ABREGO", main: "54" },
    { value: "051", text: "ARBOLEDAS", main: "54" },
    { value: "099", text: "BOCHALEMA", main: "54" },
    { value: "109", text: "BUCARASICA", main: "54" },
    { value: "125", text: "CACOTA", main: "54" },
    { value: "128", text: "CACHIRA", main: "54" },
    { value: "172", text: "CHINACOTA", main: "54" },
    { value: "174", text: "CHITAGA", main: "54" },
    { value: "206", text: "CONVENCION", main: "54" },
    { value: "223", text: "CUCUTILLA", main: "54" },
    { value: "239", text: "DURANIA", main: "54" },
    { value: "245", text: "EL CARMEN", main: "54" },
    { value: "250", text: "EL TARRA", main: "54" },
    { value: "261", text: "EL ZULIA", main: "54" },
    { value: "313", text: "GRAMALOTE", main: "54" },
    { value: "344", text: "HACARI", main: "54" },
    { value: "347", text: "HERRAN", main: "54" },
    { value: "377", text: "LABATECA", main: "54" },
    { value: "385", text: "LA ESPERANZA", main: "54" },
    { value: "398", text: "LA PLAYA", main: "54" },
    { value: "405", text: "LOS PATIOS", main: "54" },
    { value: "418", text: "LOURDES", main: "54" },
    { value: "480", text: "MUTISCUA", main: "54" },
    { value: "498", text: "OCAÑA", main: "54" },
    { value: "518", text: "PAMPLONA", main: "54" },
    { value: "520", text: "PAMPLONITA", main: "54" },
    { value: "553", text: "PUERTO SANTANDER", main: "54" },
    { value: "599", text: "RAGONVALIA", main: "54" },
    { value: "660", text: "SALAZAR", main: "54" },
    { value: "670", text: "SAN CALIXTO", main: "54" },
    { value: "673", text: "SAN CAYETANO", main: "54" },
    { value: "680", text: "SANTIAGO", main: "54" },
    { value: "720", text: "SARDINATA", main: "54" },
    { value: "743", text: "SILOS", main: "54" },
    { value: "800", text: "TEORAMA", main: "54" },
    { value: "810", text: "TIBU", main: "54" },
    { value: "820", text: "TOLEDO", main: "54" },
    { value: "871", text: "VILLA CARO", main: "54" },
    { value: "874", text: "VILLA DEL ROSARIO", main: "54" },
    { value: "001", text: "ARMENIA", main: "63" },
    { value: "111", text: "BUENAVISTA", main: "63" },
    { value: "130", text: "CALARCA", main: "63" },
    { value: "190", text: "CIRCASIA", main: "63" },
    { value: "212", text: "CORDOBA", main: "63" },
    { value: "272", text: "FILANDIA", main: "63" },
    { value: "302", text: "GENOVA", main: "63" },
    { value: "401", text: "LA TEBAIDA", main: "63" },
    { value: "470", text: "MONTENEGRO", main: "63" },
    { value: "548", text: "PIJAO", main: "63" },
    { value: "594", text: "QUIMBAYA", main: "63" },
    { value: "690", text: "SALENTO", main: "63" },
    { value: "001", text: "PEREIRA", main: "66" },
    { value: "045", text: "APIA", main: "66" },
    { value: "075", text: "BALBOA", main: "66" },
    { value: "088", text: "BELEN DE UMBRIA", main: "66" },
    { value: "170", text: "DOSQUEBRADAS", main: "66" },
    { value: "318", text: "GUATICA", main: "66" },
    { value: "383", text: "LA CELIA", main: "66" },
    { value: "400", text: "LA VIRGINIA", main: "66" },
    { value: "440", text: "MARSELLA", main: "66" },
    { value: "456", text: "MISTRATO", main: "66" },
    { value: "572", text: "PUEBLO RICO", main: "66" },
    { value: "594", text: "QUINCHIA", main: "66" },
    { value: "682", text: "SANTA ROSA DE CABAL", main: "66" },
    { value: "687", text: "SANTUARIO", main: "66" },
    { value: "001", text: "BUCARAMANGA", main: "68" },
    { value: "013", text: "AGUADA", main: "68" },
    { value: "020", text: "ALBANIA", main: "68" },
    { value: "051", text: "ARATOCA", main: "68" },
    { value: "077", text: "BARBOSA", main: "68" },
    { value: "079", text: "BARICHARA", main: "68" },
    { value: "081", text: "BARRANCABERMEJA", main: "68" },
    { value: "092", text: "BETULIA", main: "68" },
    { value: "101", text: "BOLIVAR", main: "68" },
    { value: "121", text: "CABRERA", main: "68" },
    { value: "132", text: "CALIFORNIA", main: "68" },
    { value: "147", text: "CAPITANEJO", main: "68" },
    { value: "152", text: "CARCASI", main: "68" },
    { value: "160", text: "CEPITA", main: "68" },
    { value: "162", text: "CERRITO", main: "68" },
    { value: "167", text: "CHARALA", main: "68" },
    { value: "169", text: "CHARTA", main: "68" },
    { value: "176", text: "CHIMA", main: "68" },
    { value: "179", text: "CHIPATA", main: "68" },
    { value: "190", text: "CIMITARRA", main: "68" },
    { value: "207", text: "CONCEPCION", main: "68" },
    { value: "209", text: "CONFINES", main: "68" },
    { value: "211", text: "CONTRATACION", main: "68" },
    { value: "217", text: "COROMORO", main: "68" },
    { value: "229", text: "CURITI", main: "68" },
    { value: "235", text: "EL CARMEN DE CHUCURI", main: "68" },
    { value: "245", text: "EL GUACAMAYO", main: "68" },
    { value: "250", text: "EL PEÑON", main: "68" },
    { value: "255", text: "EL PLAYON", main: "68" },
    { value: "264", text: "ENCINO", main: "68" },
    { value: "266", text: "ENCISO", main: "68" },
    { value: "271", text: "FLORIAN", main: "68" },
    { value: "276", text: "FLORIDABLANCA", main: "68" },
    { value: "296", text: "GALAN", main: "68" },
    { value: "298", text: "GAMBITA", main: "68" },
    { value: "307", text: "GIRON", main: "68" },
    { value: "318", text: "GUACA", main: "68" },
    { value: "320", text: "GUADALUPE", main: "68" },
    { value: "322", text: "GUAPOTA", main: "68" },
    { value: "324", text: "GUAVATA", main: "68" },
    { value: "327", text: "GsEPSA", main: "68" },
    { value: "344", text: "HATO", main: "68" },
    { value: "368", text: "JESUS MARIA", main: "68" },
    { value: "370", text: "JORDAN", main: "68" },
    { value: "377", text: "LA BELLEZA", main: "68" },
    { value: "385", text: "LANDAZURI", main: "68" },
    { value: "397", text: "LA PAZ", main: "68" },
    { value: "406", text: "LEBRIJA", main: "68" },
    { value: "418", text: "LOS SANTOS", main: "68" },
    { value: "425", text: "MACARAVITA", main: "68" },
    { value: "432", text: "MALAGA", main: "68" },
    { value: "444", text: "MATANZA", main: "68" },
    { value: "464", text: "MOGOTES", main: "68" },
    { value: "468", text: "MOLAGAVITA", main: "68" },
    { value: "498", text: "OCAMONTE", main: "68" },
    { value: "500", text: "OIBA", main: "68" },
    { value: "502", text: "ONZAGA", main: "68" },
    { value: "522", text: "PALMAR", main: "68" },
    { value: "524", text: "PALMAS DEL SOCORRO", main: "68" },
    { value: "533", text: "PARAMO", main: "68" },
    { value: "547", text: "PIEDECUESTA", main: "68" },
    { value: "549", text: "PINCHOTE", main: "68" },
    { value: "572", text: "PUENTE NACIONAL", main: "68" },
    { value: "573", text: "PUERTO PARRA", main: "68" },
    { value: "575", text: "PUERTO WILCHES", main: "68" },
    { value: "615", text: "RIONEGRO", main: "68" },
    { value: "655", text: "SABANA DE TORRES", main: "68" },
    { value: "669", text: "SAN ANDRES", main: "68" },
    { value: "673", text: "SAN BENITO", main: "68" },
    { value: "679", text: "SAN GIL", main: "68" },
    { value: "682", text: "SAN JOAQUIN", main: "68" },
    { value: "684", text: "SAN JOSE DE MIRANDA", main: "68" },
    { value: "686", text: "SAN MIGUEL", main: "68" },
    { value: "689", text: "SAN VICENTE DE CHUCURI", main: "68" },
    { value: "705", text: "SANTA BARBARA", main: "68" },
    { value: "720", text: "SANTA HELENA DEL OPON", main: "68" },
    { value: "745", text: "SIMACOTA", main: "68" },
    { value: "755", text: "SOCORRO", main: "68" },
    { value: "770", text: "SUAITA", main: "68" },
    { value: "773", text: "SUCRE", main: "68" },
    { value: "780", text: "SURATA", main: "68" },
    { value: "820", text: "TONA", main: "68" },
    { value: "855", text: "VALLE DE SAN JOSE", main: "68" },
    { value: "861", text: "VELEZ", main: "68" },
    { value: "867", text: "VETAS", main: "68" },
    { value: "872", text: "VILLANUEVA", main: "68" },
    { value: "895", text: "ZAPATOCA", main: "68" },
    { value: "001", text: "SINCELEJO", main: "70" },
    { value: "110", text: "BUENAVISTA", main: "70" },
    { value: "124", text: "CAIMITO", main: "70" },
    { value: "204", text: "COLOSO", main: "70" },
    { value: "215", text: "COROZAL", main: "70" },
    { value: "221", text: "COVEÑAS", main: "70" },
    { value: "230", text: "CHALAN", main: "70" },
    { value: "233", text: "EL ROBLE", main: "70" },
    { value: "235", text: "GALERAS", main: "70" },
    { value: "265", text: "GUARANDA", main: "70" },
    { value: "400", text: "LA UNION", main: "70" },
    { value: "418", text: "LOS PALMITOS", main: "70" },
    { value: "429", text: "MAJAGUAL", main: "70" },
    { value: "473", text: "MORROA", main: "70" },
    { value: "508", text: "OVEJAS", main: "70" },
    { value: "523", text: "PALMITO", main: "70" },
    { value: "670", text: "SAMPUES", main: "70" },
    { value: "678", text: "SAN BENITO ABAD", main: "70" },
    { value: "702", text: "SAN JUAN DE BETULIA", main: "70" },
    { value: "708", text: "SAN MARCOS", main: "70" },
    { value: "713", text: "SAN ONOFRE", main: "70" },
    { value: "717", text: "SAN PEDRO", main: "70" },
    { value: "742", text: "SAN LUIS DE SINCE", main: "70" },
    { value: "771", text: "SUCRE", main: "70" },
    { value: "820", text: "SANTIAGO DE TOLU", main: "70" },
    { value: "823", text: "TOLU VIEJO", main: "70" },
    { value: "001", text: "IBAGUE", main: "73" },
    { value: "024", text: "ALPUJARRA", main: "73" },
    { value: "026", text: "ALVARADO", main: "73" },
    { value: "030", text: "AMBALEMA", main: "73" },
    { value: "043", text: "ANZOATEGUI", main: "73" },
    { value: "055", text: "ARMERO", main: "73" },
    { value: "067", text: "ATACO", main: "73" },
    { value: "124", text: "CAJAMARCA", main: "73" },
    { value: "148", text: "CARMEN DE APICALA", main: "73" },
    { value: "152", text: "CASABIANCA", main: "73" },
    { value: "168", text: "CHAPARRAL", main: "73" },
    { value: "200", text: "COELLO", main: "73" },
    { value: "217", text: "COYAIMA", main: "73" },
    { value: "226", text: "CUNDAY", main: "73" },
    { value: "236", text: "DOLORES", main: "73" },
    { value: "268", text: "ESPINAL", main: "73" },
    { value: "270", text: "FALAN", main: "73" },
    { value: "275", text: "FLANDES", main: "73" },
    { value: "283", text: "FRESNO", main: "73" },
    { value: "319", text: "GUAMO", main: "73" },
    { value: "347", text: "HERVEO", main: "73" },
    { value: "349", text: "HONDA", main: "73" },
    { value: "352", text: "ICONONZO", main: "73" },
    { value: "408", text: "LERIDA", main: "73" },
    { value: "411", text: "LIBANO", main: "73" },
    { value: "443", text: "MARIQUITA", main: "73" },
    { value: "449", text: "MELGAR", main: "73" },
    { value: "461", text: "MURILLO", main: "73" },
    { value: "483", text: "NATAGAIMA", main: "73" },
    { value: "504", text: "ORTEGA", main: "73" },
    { value: "520", text: "PALOCABILDO", main: "73" },
    { value: "547", text: "PIEDRAS", main: "73" },
    { value: "555", text: "PLANADAS", main: "73" },
    { value: "563", text: "PRADO", main: "73" },
    { value: "585", text: "PURIFICACION", main: "73" },
    { value: "616", text: "RIOBLANCO", main: "73" },
    { value: "622", text: "RONCESVALLES", main: "73" },
    { value: "624", text: "ROVIRA", main: "73" },
    { value: "671", text: "SALDAÑA", main: "73" },
    { value: "675", text: "SAN ANTONIO", main: "73" },
    { value: "678", text: "SAN LUIS", main: "73" },
    { value: "686", text: "SANTA ISABEL", main: "73" },
    { value: "770", text: "SUAREZ", main: "73" },
    { value: "854", text: "VALLE DE SAN JUAN", main: "73" },
    { value: "861", text: "VENADILLO", main: "73" },
    { value: "870", text: "VILLAHERMOSA", main: "73" },
    { value: "873", text: "VILLARRICA", main: "73" },
    { value: "001", text: "CALI", main: "76" },
    { value: "020", text: "ALCALA", main: "76" },
    { value: "036", text: "ANDALUCIA", main: "76" },
    { value: "041", text: "ANSERMANUEVO", main: "76" },
    { value: "054", text: "ARGELIA", main: "76" },
    { value: "100", text: "BOLIVAR", main: "76" },
    { value: "109", text: "BUENAVENTURA", main: "76" },
    { value: "111", text: "GUADALAJARA DE BUGA", main: "76" },
    { value: "113", text: "BUGALAGRANDE", main: "76" },
    { value: "122", text: "CAICEDONIA", main: "76" },
    { value: "126", text: "CALIMA", main: "76" },
    { value: "130", text: "CANDELARIA", main: "76" },
    { value: "147", text: "CARTAGO", main: "76" },
    { value: "233", text: "DAGUA", main: "76" },
    { value: "243", text: "EL AGUILA", main: "76" },
    { value: "246", text: "EL CAIRO", main: "76" },
    { value: "248", text: "EL CERRITO", main: "76" },
    { value: "250", text: "EL DOVIO", main: "76" },
    { value: "275", text: "FLORIDA", main: "76" },
    { value: "306", text: "GINEBRA", main: "76" },
    { value: "318", text: "GUACARI", main: "76" },
    { value: "364", text: "JAMUNDI", main: "76" },
    { value: "377", text: "LA CUMBRE", main: "76" },
    { value: "400", text: "LA UNION", main: "76" },
    { value: "403", text: "LA VICTORIA", main: "76" },
    { value: "497", text: "OBANDO", main: "76" },
    { value: "520", text: "PALMIRA", main: "76" },
    { value: "563", text: "PRADERA", main: "76" },
    { value: "606", text: "RESTREPO", main: "76" },
    { value: "616", text: "RIOFRIO", main: "76" },
    { value: "622", text: "ROLDANILLO", main: "76" },
    { value: "670", text: "SAN PEDRO", main: "76" },
    { value: "736", text: "SEVILLA", main: "76" },
    { value: "823", text: "TORO", main: "76" },
    { value: "828", text: "TRUJILLO", main: "76" },
    { value: "834", text: "TULUA", main: "76" },
    { value: "845", text: "ULLOA", main: "76" },
    { value: "863", text: "VERSALLES", main: "76" },
    { value: "869", text: "VIJES", main: "76" },
    { value: "890", text: "YOTOCO", main: "76" },
    { value: "892", text: "YUMBO", main: "76" },
    { value: "895", text: "ZARZAL", main: "76" },
    { value: "001", text: "ARAUCA", main: "81" },
    { value: "065", text: "ARAUQUITA", main: "81" },
    { value: "220", text: "CRAVO NORTE", main: "81" },
    { value: "300", text: "FORTUL", main: "81" },
    { value: "591", text: "PUERTO RONDON", main: "81" },
    { value: "736", text: "SARAVENA", main: "81" },
    { value: "794", text: "TAME", main: "81" },
    { value: "001", text: "YOPAL", main: "85" },
    { value: "010", text: "AGUAZUL", main: "85" },
    { value: "015", text: "CHAMEZA", main: "85" },
    { value: "125", text: "HATO COROZAL", main: "85" },
    { value: "136", text: "LA SALINA", main: "85" },
    { value: "139", text: "MANI", main: "85" },
    { value: "162", text: "MONTERREY", main: "85" },
    { value: "225", text: "NUNCHIA", main: "85" },
    { value: "230", text: "OROCUE", main: "85" },
    { value: "250", text: "PAZ DE ARIPORO", main: "85" },
    { value: "263", text: "PORE", main: "85" },
    { value: "279", text: "RECETOR", main: "85" },
    { value: "300", text: "SABANALARGA", main: "85" },
    { value: "315", text: "SACAMA", main: "85" },
    { value: "325", text: "SAN LUIS DE PALENQUE", main: "85" },
    { value: "400", text: "TAMARA", main: "85" },
    { value: "410", text: "TAURAMENA", main: "85" },
    { value: "430", text: "TRINIDAD", main: "85" },
    { value: "440", text: "VILLANUEVA", main: "85" },
    { value: "001", text: "MOCOA", main: "86" },
    { value: "219", text: "COLON", main: "86" },
    { value: "320", text: "ORITO", main: "86" },
    { value: "568", text: "PUERTO ASIS", main: "86" },
    { value: "569", text: "PUERTO CAICEDO", main: "86" },
    { value: "571", text: "PUERTO GUZMAN", main: "86" },
    { value: "573", text: "LEGUIZAMO", main: "86" },
    { value: "749", text: "SIBUNDOY", main: "86" },
    { value: "755", text: "SAN FRANCISCO", main: "86" },
    { value: "757", text: "SAN MIGUEL", main: "86" },
    { value: "760", text: "SANTIAGO", main: "86" },
    { value: "865", text: "VALLE DEL GUAMUEZ", main: "86" },
    { value: "885", text: "VILLAGARZON", main: "86" },
    { value: "001", text: "SAN ANDRES", main: "88" },
    { value: "564", text: "PROVIDENCIA", main: "88" },
    { value: "001", text: "LETICIA", main: "91" },
    { value: "263", text: "EL ENCANTO", main: "91" },
    { value: "405", text: "LA CHORRERA", main: "91" },
    { value: "407", text: "LA PEDRERA", main: "91" },
    { value: "430", text: "LA VICTORIA", main: "91" },
    { value: "460", text: "MIRITI - PARANA", main: "91" },
    { value: "530", text: "PUERTO ALEGRIA", main: "91" },
    { value: "536", text: "PUERTO ARICA", main: "91" },
    { value: "540", text: "PUERTO NARIÑO", main: "91" },
    { value: "669", text: "PUERTO SANTANDER", main: "91" },
    { value: "798", text: "TARAPACA", main: "91" },
    { value: "001", text: "INIRIDA", main: "94" },
    { value: "343", text: "BARRANCO MINAS", main: "94" },
    { value: "663", text: "MAPIRIPANA", main: "94" },
    { value: "883", text: "SAN FELIPE", main: "94" },
    { value: "884", text: "PUERTO COLOMBIA", main: "94" },
    { value: "885", text: "LA GUADALUPE", main: "94" },
    { value: "886", text: "CACAHUAL", main: "94" },
    { value: "887", text: "PANA PANA", main: "94" },
    { value: "888", text: "MORICHAL", main: "94" },
    { value: "001", text: "SAN JOSE DEL GUAVIARE", main: "95" },
    { value: "015", text: "CALAMAR", main: "95" },
    { value: "025", text: "EL RETORNO", main: "95" },
    { value: "200", text: "MIRAFLORES", main: "95" },
    { value: "001", text: "MITU", main: "97" },
    { value: "161", text: "CARURU", main: "97" },
    { value: "511", text: "PACOA", main: "97" },
    { value: "666", text: "TARAIRA", main: "97" },
    { value: "777", text: "PAPUNAUA", main: "97" },
    { value: "889", text: "YAVARATE", main: "97" },
    { value: "001", text: "PUERTO CARREÑO", main: "99" },
    { value: "524", text: "LA PRIMAVERA", main: "99" },
    { value: "624", text: "SANTA ROSALIA", main: "99" },
    { value: "773", text: "CUMARIBO", main: "99" },
  ];

  public static departments: Category[] = [
    { value: "05", text: "ANTIOQUIA" },
    { value: "08", text: "ATLANTICO" },
    { value: "11", text: "BOGOTA" },
    { value: "13", text: "BOLIVAR" },
    { value: "15", text: "BOYACA" },
    { value: "17", text: "CALDAS" },
    { value: "18", text: "CAQUETA" },
    { value: "19", text: "CAUCA" },
    { value: "20", text: "CESAR" },
    { value: "23", text: "CORDOBA" },
    { value: "25", text: "CUNDINAMARCA" },
    { value: "27", text: "CHOCO" },
    { value: "41", text: "HUILA" },
    { value: "44", text: "LA GUAJIRA" },
    { value: "47", text: "MAGDALENA" },
    { value: "50", text: "META" },
    { value: "52", text: "NARIÑO" },
    { value: "54", text: "N. DE SANTANDER" },
    { value: "63", text: "QUINDIO" },
    { value: "66", text: "RISARALDA" },
    { value: "68", text: "SANTANDER" },
    { value: "70", text: "SUCRE" },
    { value: "73", text: "TOLIMA" },
    { value: "76", text: "VALLE DEL CAUCA" },
    { value: "81", text: "ARAUCA" },
    { value: "85", text: "CASANARE" },
    { value: "86", text: "PUTUMAYO" },
    { value: "88", text: "SAN ANDRES" },
    { value: "91", text: "AMAZONAS" },
    { value: "94", text: "GUAINIA" },
    { value: "95", text: "GUAVIARE" },
    { value: "97", text: "VAUPES" },
    { value: "99", text: "VICHADA" },
  ];

  public getCatalog(catalog: string): Category[] {
    switch (catalog) {
      case CatalogsEnum.cities: {
        return CatalogCo.cities;
      }
      case CatalogsEnum.departments: {
        return CatalogCo.departments;
      }
      // istanbul ignore next
      default: {
        return [];
      }
    }
  }
}

/**
 * CatalogsEnum
 */
export enum CatalogsEnum {
  cities = "cities",
  departments = "departments",
}



// WEBPACK FOOTER //
// ./src/shared/Catalog/CatalogColombia.ts